export default {

    LOAD_BUDGET(state, budge) {
        state.items = budge;
    }

}